import React from "react";

interface CheckboxInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  id?: string;
  label?: string;
  checked?: boolean;
  required?: boolean;
  className?: string;
  labelClassName?: string;
  linkLabel?: string;
  linkUrl?: string;
}

export const GenericCheckbox: React.FC<CheckboxInputProps> = ({
  id = "checkbox",
  label = "",
  checked = false,
  required = false,
  onChange,
  className = "w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600",
  labelClassName = "ml-2 text-sm font-medium text-gray-900 dark:text-gray-300",
  linkLabel,
  linkUrl,
}) => {
  return (
    <div className="flex items-center">
      <input
        id={id}
        type="checkbox"
        checked={checked}
        required={required}
        onChange={onChange}
        className={className}
      />
      <label htmlFor={id} className={labelClassName}>
        {label}
        {linkLabel && linkUrl && (
          <>
            {" "}
            <a
              href={linkUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 dark:text-blue-500 hover:underline"
            >
              {linkLabel}
            </a>
          </>
        )}
      </label>
    </div>
  );
};
